import React from 'react';
import { renderTextWithNormalDash } from '../../utils/textFormatters';

const ReviewCard = ({ text, name, org, img, idx, translate, isAnimating }) => (

    <div className="review-card" style={{
        transform: `translateX(${translate}%)`,
        transition: isAnimating ? 'transform 0.4s ease' : 'none'
    }}>
        <p className="review-text">{renderTextWithNormalDash(text)}</p>
        <div className="review-footer d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
                <img src={img} alt="avatar" className="review-avatar" />
                <div className="review-person">
                    <div className="review-name">{name}</div>
                    <div className="review-org">{org}</div>
                </div>
            </div>

            <div className="review-stars">
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
            </div>
        </div>
    </div>
)

export default ReviewCard;